// Values the system already knows for a gate's flight, keyed by placeholder name
// (case-insensitive). {AirlineCode} gets the airline NAME: templates read
// "{AirlineCode} flight {FlightNumber}", and the flight number already carries
// the code ("Singapore Airlines flight SQ764", not "SQ flight SQ764").
export function knownPlaceholderValues(placeholders, { gate, session } = {}) {
  const flight = session?.flight_number || '';
  const gateCode = gate?.gate_code || session?.gate?.gate_code || '';
  const known = {
    flightnumber: flight,
    gate: gateCode,
    oldgate: gateCode, // gate-change templates: the gate the flight is at now
    destination: session?.destination || '',
    airlinecode: session?.airline || (flight.match(/^[A-Z0-9]{2}/)?.[0] ?? ''),
    airline: session?.airline || '',
  };
  const out = {};
  for (const p of placeholders || []) {
    const v = known[String(p).toLowerCase()];
    if (v) out[p] = v;
  }
  return out;
}

// Fill known values into empty fields only — never overwrite what the user typed.
// Returns the same object when nothing changes, so it's safe inside an effect.
export function fillEmpty(values, known) {
  let next = values;
  for (const [k, v] of Object.entries(known)) {
    if (!values[k]?.toString().trim()) {
      if (next === values) next = { ...values };
      next[k] = v;
    }
  }
  return next;
}

// Gate PA requests (ad-hoc / template) only offer Airport-category templates —
// Hospital / Retail / School / Transportation ones don't belong on a gate.
export const isAirportTemplate = (t) => String(t?.category || '').trim().toLowerCase() === 'airport';
